'use client';
import { useMediaQuery } from "react-responsive";
import { personalInfoLink, serviceLink } from "@/constants/index";
import useDevice from "@/hooks/useDevice";
import Image from "next/image";
import { useLanguage } from "@/context/LanguageContext";

type CodiMeFooterProps = {
  baseColor?: string; //baseColor: black/white
};

const TextLine = ({ baseColor }: CodiMeFooterProps) => {
  if (baseColor == "black") return <span className="trans-white-9">|</span>;
  else return <span className="trans-gray-950-20">|</span>;
};

//baseColor: black/white
const Footer = ({ baseColor = "black" }: CodiMeFooterProps) => {
  const { t, locale } = useLanguage();
  const isMobile = useMediaQuery({
    query: "(max-width:1199px)",
  });

  if (isMobile)
    return (
      <div className={`footer-box ${baseColor === "black" ? "" : "white-basecolor"}`}>
        <Image src="/header-logo.png" alt="Logo" width={94.33}
          height={20} />
        <div className="column flex-start gap-16">
          <span className="body2-700">{t.footer.companyName}</span>
          <p className="caption-500" style={{ margin: 0 }}>
            {t.footer.representative} <TextLine baseColor={baseColor} /> {t.footer.businessRegistrationNumber}{" "}
            <TextLine baseColor={baseColor} />
            <br />
            {" "}{t.footer.officeAddress}{" "} <TextLine baseColor={baseColor} /> {" "} <br />
            {t.footer.mainOfficeAddress}{" "}
            <TextLine baseColor={baseColor} /> 070-7174-2091 <TextLine baseColor={baseColor} />
            <br />
            {t.footer.email}
            {locale === 'ko' && (
              <>
                {" "}<TextLine baseColor={baseColor} /> {t.footer.telecomSaleRegistrationNumber}
              </>
            )}

          </p>
          <div className="row justify-start gap-8 align-center">
            <a target="_blank" href={serviceLink} className="body2-400 anchor" style={{ textDecoration: 'none' }}>
              {t.footer.termsOfService}
            </a>
            <TextLine baseColor={baseColor} />
            <a
              target="_blank"
              href={personalInfoLink}
              className="body2-700 text-underline anchor"
              style={{ textDecoration: 'none' }}
            >
              {t.footer.privacyPolicy}
            </a>
          </div>
        </div>
        <span className="caption-500 copyright">Copyright 2025 CodiMe Co., Ltd. All rights reserved.</span>
      </div>
    );
  //desktop
  else
    return (
      <div className={`desktop-potoo-footer-box ${baseColor === "black" ? "" : "white-basecolor"}`}>
        <div className="desktop-potoo-footer-container">
          <div className="row">
            <div
              style={{
                width: 94.33,
                height: 20,
              }}
            >
              <Image src="/header-logo.png" alt="Logo" width={94.33}
                height={20} />
            </div>
            <div className="column flex-start gap-9" style={{ marginLeft: 30 }}>
              <span className="body2-700">{t.footer.companyName}</span>
              <p className="caption-500" style={{ margin: 0 }}>
                {t.footer.representative} <TextLine baseColor={baseColor} /> {t.footer.businessRegistrationNumber}{" "}
                <TextLine baseColor={baseColor} />
                {" "}{t.footer.officeAddress}{" "}<TextLine baseColor={baseColor} /> {" "}
                {t.footer.mainOfficeAddress}
                <TextLine baseColor={baseColor} /> {t.footer.phone}
                <TextLine baseColor={baseColor} />{" "}
                {t.footer.email}
                {locale === 'ko' && (
                  <>
                    {" "}<TextLine baseColor={baseColor} /> {t.footer.telecomSaleRegistrationNumber}
                  </>
                )}
              </p>
              <div className="row justify-start gap-8 align-center">
                <a target="_blank" href={serviceLink} className="body2-400 anchor" style={{ textDecoration: 'none' }}>
                  {t.footer.termsOfService}
                </a>
                <TextLine baseColor={baseColor} />
                <a target="_blank" href={personalInfoLink} className="body2-700 anchor" style={{ textDecoration: 'none' }}>
                  {t.footer.privacyPolicy}
                </a>
              </div>
            </div>
          </div>

          <span
            className="caption-500 no-enter copyright"
            style={{ marginLeft: 32, alignSelf: "end" }}
          >
            Copyright 2025 CodiMe Co., Ltd. All rights reserved.
          </span>
        </div>
      </div>
    );
};

export { Footer };
